// Object URLs handed to the app as `uri`, mapped back to the File they came from.
// Lets unchanged app code append `{ uri, name, type }` to FormData (see polyfills.ts).
const files = new Map<string, Blob>();

export function registerFile(blob: Blob): string {
  const uri = URL.createObjectURL(blob);
  files.set(uri, blob);
  return uri;
}

export function fileForUri(uri: string): Blob | undefined {
  return files.get(uri);
}

export function releaseUri(uri: string) {
  files.delete(uri);
  URL.revokeObjectURL(uri);
}
